"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectionMode = void 0;
/**
 * @see https://api.prezly.com/v2/common/schema.json#/definitions/Pagination
 */
let SelectionMode = exports.SelectionMode = /*#__PURE__*/function (SelectionMode) {
  SelectionMode["ALL"] = "all";
  SelectionMode["IN"] = "in";
  SelectionMode["NOT_IN"] = "not_in";
  return SelectionMode;
}({});